import { useBounds } from '@react-three/drei';
import { useLoader } from '@react-three/fiber';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader';
import { useEffect } from 'react';
import { Box3, Mesh, Vector3 } from 'three';
import type { ModelProps } from '@hub/common/ModelViewer/ModelViewer';

export const StlModel = ({ modelUrl, materialColor, setModelSize }: ModelProps) => {
  const bounds = useBounds();
  const geometry = useLoader(STLLoader, modelUrl);

  useEffect(() => {
    const mesh = new Mesh(geometry);
    const box = new Box3().setFromObject(mesh);
    const center = new Vector3();
    const size = new Vector3();
    box.getCenter(center);
    box.getSize(size);

    setModelSize(size);

    bounds?.refresh().reset().clip().fit();
  }, [geometry]);

  return (
    <mesh geometry={geometry}>
      <meshStandardMaterial color={materialColor} />
    </mesh>
  );
};
